export const WHATSAPP_URL =
  'https://wa.me/5538998727085?text=Olá! Gostaria de agendar uma demonstração do sistema SwimmingPool.'
